import React from "react";
import { useTranslation } from "react-i18next";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import DeleteIcon from "@mui/icons-material/Delete";

import Button from "../Button";
import TableComponent from "../TableComponent";

const PropertiesList = ({ userProperties, onDelete }) => {
  const { t } = useTranslation();

  return (
    <TableComponent
      header={[
        { title: t("property"), style: { width: "95%" } },
        { title: t("actions"), style: { width: "5%" } },
      ]}
      items={userProperties}
      renderChildren={(property) => (
        <TableRow key={`${property.roleId}-${property.positionId}-${property.operationId}`}>
          <TableCell>{property.label}</TableCell>
          <TableCell>
            <Button title={t("delete_property")} onClick={() => onDelete(property)} icon={<DeleteIcon color="error" />} />
          </TableCell>
        </TableRow>
      )}
    />
  );
};

export default PropertiesList;
